// extracted by css-extract-rspack-plugin
export default {"usefulQuestions":"R3BGG Trxz5"};